<style scoped>
    @import url("../../styles/smartControl/manejoIA.scss");
</style>

<template>
    <div class="box_manejoIA">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-brain</v-icon>
            <span class="ml-2">Decisões</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema">
            
            <div class="titPainel">
                <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-brain</v-icon>
                <span class="ml-2">Decisão em tempo real</span>
            </div>

            <HistIaIrrig />
        </div>

        <div class="painelGeral" v-if="!flagLoading && flagMsgIAOFF && !flagMsgSistema">
            <span>Modelo diário por IA desabilitado.</span>
        </div>

        <!-- atuadores diários (se algum atudor habilitado com IA) -->
        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema && !flagMsgIAOFF">

            <div class="titPainel">
                <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-wrench-cog</v-icon>
                <span class="ml-2">Atuadores sob gestão diária por IA</span>
            </div>
            
            <AtuadoresSobIA 
            class="ml-8"
            />

        </div>
        
        <!-- textos diários -->
        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema && !flagMsgIAOFF">

            <div class="titPainel">
                <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-brain</v-icon>
                <span class="ml-2">Resumo da decisão diária</span>
            </div>

            <HistDailyIA 
            :liResIA="liResIA"
            />
            
            <!--<CardIA v-for="(c, i) in liResIA" :key="i" :td="c.data" :txt="c.resposta" />-->

        </div>

    </div>
</template>

<script>
import AtuadoresSobIA from './AtuadoresSobIA'
//import CardIA from './CardIA'

import HistIaIrrig from './subManejoIA/HistIAIrrig'
import HistDailyIA from './subManejoIA/HistDailyIA'

import axios from 'axios'

export default {

    components:{AtuadoresSobIA,HistIaIrrig,HistDailyIA},

    data() {
        return {
            //
            liResIA:[],
            flagMsgIAOFF:false, // habilita msg de IA desabilitada caso lista vazia.

            //
            flagLoading:true,

            // sistema selecionado pelo atual cliente logado.
            sistema:'',

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false 

            this.flagMsgIAOFF = false
        
            // iniciar com manuseio da escolha de qual sistema utilizar
            //this.sistema = 'upinc1'
            this.sistema = this.$store.state.sistemaSC // 14/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            //let cl = contentUser.email // de volta ao padrao 08/07/2025
            //cl = "cliente2" // temporário
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            let self = this

            //let params = {'cliente':cl, 'flag_front':'json'} // -- teste 04/05/2025
            let params = {'cliente':cl, 'sistema':this.sistema, 'flag_front':'json'} // -- teste 07/08/2025

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                //console.log('----')
                //self.liResIA = res.data.result
                //self.liResIA = self.liResIA.reverse();

                // ( v2 ) --> 14/08/2025
                //self.liResIA = el['res_ia']

                const el = res.data.result
                console.log(typeof el);
                console.log(el);
                
                // ( v3 ) --> 07/08/2026
                if (el && typeof el === "object" && "res_ia" in el) {
                    self.liResIA = el["res_ia"];
                }
                else { self.liResIA = []; }

                if (self.liResIA.length > 0) { self.liResIA = self.liResIA.reverse(); }
                else { self.flagMsgIAOFF = true }

                self.flagLoading = false
            })
        }
    }
}
</script>